import React, { useState } from "react";
import { Upload, message, Progress } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { FilesAPI } from "~/services/FilesAPI";
import { getDownloadURL } from "firebase/storage";

const { Dragger } = Upload;

export type FileInputProps = {
  keyName?: string;
  filePath?: string;
  uploadHint?: string;
  title: string;
  type: "image" | "image,pdf" | "image,pdf,audio";
  onChangeHandler: (event: { target: { name: string; value: string } }) => void;
};



const FileInput: React.FC<FileInputProps> = ({ 
  keyName = "", 
  onChangeHandler, 
  filePath = "", 
  title, 
  type, 
  uploadHint 
}) => {
  const [imageUploadProgress, setImageUploadProgress] = useState<number | null>(null);

  const handleFileUpload = (file: any) => {
    const { uploadTask, uploadRef } = FilesAPI.uploadFile({ file }, filePath);

    uploadTask.on(
      "state_changed",
      (snapshot: { bytesTransferred: number; totalBytes: number; }) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setImageUploadProgress(progress);
      },
      (error: any) => {
        console.log({ error });
        setImageUploadProgress(null);
      },
      () => {
        getDownloadURL(uploadRef).then((userFileUrl: any) => {
            message.success(`${file.name} file uploaded successfully.`);

            // The onChange Handler expects events in the format event.target.name and event.target.value
            const onUploadEvent = {
              target: {
                name: keyName,
                value: userFileUrl,
              }
            };
  
            onChangeHandler(onUploadEvent);
            setImageUploadProgress(null);
        });
      }
    );
  };

  const draggerProps: any = {
    name: "file",
    multiple: false,
    showUploadList: false,
    customRequest: handleFileUpload as any,
    onChange(info: { file: { name?: any; status?: any; }; }) {
      const { status } = info.file;
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  if (type === "image") {
    draggerProps.accept = "image/*";
  } else if (type === "image,pdf") {
    draggerProps.accept = "image/*,application/pdf";
  } else if (type === "image,pdf,audio") {
    draggerProps.accept = "image/*,application/pdf,audio/*";
  }

  return (
    <div>
      <Dragger {...draggerProps}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag a file to this area to upload {title}</p>
        {uploadHint && (
          <p className="ant-upload-hint">
            {uploadHint}
          </p>
        )}
      </Dragger>
      {imageUploadProgress && (
        <div className="progress-div mt-4">
          <Progress
            type="line"
            strokeColor="#87d068"
            percent={imageUploadProgress}
          />
        </div>
      )}
    </div>
  );
};

export default FileInput;